import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import Select from "react-select";
import Permisos from "./Permisos";
import Reportes from "./Reportes";

const Switch = ({key, name, checked, onChange, defaultChecked }) => {
	return <label className="switch switch-3d pretty switch-success mr-3">
		<input
			key={key}
			type="checkbox"
			className="switch-input"
			id={name}
			name={name}
			value="1"
			checked={checked}
			onChange={onChange}
			defaultChecked={defaultChecked}
		/>
		<span className="switch-label" />
		<span className="switch-handle" />
	</label>;
};

const Form = ({usuario, errors, sucursales, almacenes, cuentas}) => {
	const [empleados, setEmpleados] = useState([]);
	const [cuentasUsuario, setCuentasUsuario] = useState([]);
	const [sucursalesUsuario, setSucursalesUsuario] = useState([]);
	const [almacenesUsuario, setAlmacenesUsuario] = useState([]);
	const rol = usuario?.rol ? (usuario.rol === 'personalizado' ? null : usuario?.rol) : null;
	const [esVendedor, setEsVendedor] = useState(rol ? (rol.includes("vendedor") || rol.includes("cobrador")) : (usuario?.es_vendedor || false));
	const [selectedTab, setSelectedTab] = useState("datos");

	const getVendedoresForDropdown = () => {
		request("empleados?limit=100").then((res) => {
			setEmpleados(res.data.map((empleado) => ({
				value: empleado.id,
				label: `${empleado.codigo} ${empleado.nombre} ${empleado.apellido}`,
			})));
		});
	};

	const changeSelectedSucursales = (values) => {
		setSucursalesUsuario(values);
	};

	const changeSelectedAlmacenes = (values) => {
		setAlmacenesUsuario(values);
	};

	const changeSelectedCuentas = (values) => {
		setCuentasUsuario(values);
	};

	useEffect(()=> {
		getVendedoresForDropdown();
		setSucursalesUsuario(usuario?.sucursales?.map(
			(sucursal) => ({
				value: sucursal.id,
				label: sucursal.nombre,
			})
		));
		setAlmacenesUsuario(usuario?.almacenes?.map(
			(almacen) => ({
				value: almacen.id,
				label: almacen.nombre,
			})
		));
		setCuentasUsuario(usuario?.cuentas?.map(
			(cuenta) => ({
				value: cuenta.id,
				label: cuenta.nombre,
			})
		));
	}, []);

	const esSuperAdmin = rol === 'super-admin';

	return (<>
		<input type="hidden" className="text-input form-control" id="role" name="role" value={'personalizado'} />

		<ul className="nav nav-tabs pretty">
			<li className="nav-item cursor-pointer" onClick={() => setSelectedTab("datos")}>
				<span className={`nav-link${selectedTab === "datos" ? " active" : ""}`}>
					<i className="zmdi zmdi-account"></i> Datos
				</span>
			</li>

			<li className="nav-item cursor-pointer" onClick={() => setSelectedTab("permisos")}>
				<span className={`nav-link${selectedTab === "permisos" ? " active" : ""}`}>
					<i className="zmdi zmdi-shield-security"></i> Permisos
				</span>
			</li>

			<li className="nav-item cursor-pointer" onClick={() => setSelectedTab("reportes")}>
				<span className={`nav-link${selectedTab === "reportes" ? " active" : ""}`}>
					<i className="zmdi zmdi-chart"></i> Reportes
				</span>
			</li>
		</ul>

		<div className="row m-0 p-0">
			<div className="col-12 border-right border-bottom border-left" style={{display: selectedTab === 'datos' ? 'block' : 'none', borderWidth: '2px !important', borderColor: '#ccc !important'}}>
				<div className="py-2" style={{display: 'grid', columnGap: '1rem', gridTemplateColumns: '1fr 1fr', alignItems: 'center'}}>
					<div className="row form-group">
						<div className="col col-md-5">
							<label className="label form-control-label">
								Nombre de Usuario:
							</label>
						</div>
						<div className="col-12 col-md-7">
							<input
								type="text"
								className="text-input form-control"
								id="username"
								name="username"
								defaultValue={usuario.usuario}
							/>
							{errors.username && (
								<small className="help-blockParams form-Text">
									{errors.username[0]}
								</small>
							)}
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-3">
							<label className="label form-control-label">
								Es vendedor:
							</label>
						</div>
						<div className="col-md-9">
							<Switch key={usuario.id} name="es_vendedor" checked={esVendedor} onChange={(e) => {
								setEsVendedor(e.target.checked);
							}} />
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-5">
							<label className="label form-control-label">
								Nombre:
							</label>
						</div>
						<div className="col-md-7">
							<input
								type="text"
								className="text-input form-control"
								id="nombre"
								name="nombre"
								defaultValue={usuario.nombre}
							/>
							{errors.nombre && (
								<small className="help-blockParams form-Text">
									{errors.nombre[0]}
								</small>
							)}
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-3">
							<label className="label form-control-label">
								Apellido:
							</label>
						</div>
						<div className="col-md-9">
							<input
								type="text"
								className="text-input form-control"
								id="apellido"
								name="apellido"
								defaultValue={usuario.apellido}
							/>
							{errors.apellido && (
								<small className="help-blockParams form-Text">
									{errors.apellido[0]}
								</small>
							)}
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-5">
							<label className="label form-control-label">
								Activo:
							</label>
						</div>
						<div className="col-md-7">
							<Switch key={usuario.id} name="active" defaultChecked={usuario.estado ? true : false} />
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-3">
							<label className="label form-control-label">
								Email
							</label>
						</div>
						<div className="col-md-9">
							<input
								type="email"
								className="text-input form-control"
								id="email"
								name="email"
								defaultValue={usuario.email}
							/>
							{errors.email && (
								<small className="help-blockParams form-Text">
									{errors.email[0]}
								</small>
							)}
						</div>
					</div>

					{auth.is("super-admin") && (
						<div className="row form-group">
							<div className="col col-md-5">
								<label className="label form-control-label">
									Es Super Admin:
								</label>
							</div>
							<div className="col-md-7">
								<Switch key={usuario.id} name="es_super_admin" defaultChecked={esSuperAdmin ? true : false} />
							</div>
						</div>
					)}

					<div className="row form-group">
						<div className="col col-md-3">
							<label className="label form-control-label">
								Empleado:
							</label>
						</div>
						<div className="col-md-9">
							<Select
								name="empleado_id"
								options={empleados}
								defaultValue={
									usuario.empleado && {
										value: usuario.empleado?.id,
										label: `${usuario.empleado?.codigo} ${usuario.empleado?.nombre} ${usuario.empleado?.apellido}`,
									}
								}
								styles={{
									control: (styles) => ({
										...styles,
										height: "38px",
									}),
								}}
							/>
							{errors.empleado_id && (
								<small className="help-blockParams form-Text">
									{errors.empleado_id[0]}
								</small>
							)}
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-5">
							<label className="label form-control-label">
								Contraseña
							</label>
						</div>
						<div className="col-md-7">
							<input
								type="password"
								className="text-input form-control"
								id="password"
								name="password"
							/>
							{errors.password && (
								<small className="help-blockParams form-Text">
									{errors.password[0]}
								</small>
							)}
						</div>
					</div>

					{!auth.is("admin") && (
						<div className="row form-group">
							<div className="col col-md-3">
								<label className="label form-control-label">
									Sucursales
								</label>
							</div>
							<div className="col-md-9">
								<Select
									options={sucursales.map((sucursal) => ({
										value: sucursal.id,
										label: sucursal.nombre,
									}))}
									isMulti
									name="sucursales[]"
									onChange={(e) =>
										changeSelectedSucursales(e)
									}
									value={sucursalesUsuario}
									menuPortalTarget={document.body}
									styles={{
										menuPortal: (base) => ({
											...base,
											zIndex: 9999,
										}),
									}}
								/>
							</div>
						</div>
					)}

					{auth.is("admin") && (
						<input
							type="hidden"
							name="sucursales[]"
							value={auth.getUser().sucursalActual}
						/>
					)}

					<div className="row form-group">
						<div className="col col-md-5">
							<label className="label form-control-label">
								Confirmar Contraseña
							</label>
						</div>
						<div className="col-md-7">
							<input
								type="password"
								className="text-input form-control"
								id="password_confirmation"
								name="password_confirmation"
							/>
						</div>
					</div>

					<div className="row form-group">
						<div className="col col-md-3">
							<label className="label form-control-label">
								Almacenes
							</label>
						</div>
						<div className="col-md-9">
							<Select
								options={almacenes.map((almacen) => ({
									value: almacen.id,
									label: almacen.nombre,
								}))}
								isMulti
								name="almacenes[]"
								onChange={(e) =>
									changeSelectedAlmacenes(e)
								}
								value={almacenesUsuario}
								menuPortalTarget={document.body}
								styles={{
									menuPortal: (base) => ({
										...base,
										zIndex: 9999,
									}),
								}}
							/>
						</div>
					</div>

					<div className="row form-group" style={{gridColumn: '1 / span 2'}}>
						<div className="col col-frame-special">
							<label className="label form-control-label">
								Cuentas bancarias
							</label>
						</div>

						<div className="col-md">
							<Select
								options={cuentas.map((cuenta) => ({
									value: cuenta.id,
									label: cuenta.nombre,
								}))}
								isMulti
								name="cuentas[]"
								onChange={(e) =>
									changeSelectedCuentas(e)
								}
								value={cuentasUsuario}
								menuPortalTarget={document.body}
								styles={{
									menuPortal: (base) => ({
										...base,
										zIndex: 9999,
									}),
								}}
							/>

							{errors.cuentas && (
								<small className="help-blockParams form-Text">
									{errors.cuentas[0]}
								</small>
							)}
						</div>
					</div>
				</div>
			</div>

			<div className="col-12 border-right border-bottom border-left" style={{display: selectedTab === 'permisos' ? 'block' : 'none', borderWidth: '2px !important', borderColor: '#ccc !important'}}>
				<Permisos permisosUsuario={usuario.permisos?.filter(p => !p.includes("reporte:"))} rol={rol} />
			</div>

			<div className="col-12 border-right border-bottom border-left" style={{display: selectedTab === 'reportes' ? 'block' : 'none', borderWidth: '2px !important', borderColor: '#ccc !important'}}>
				<Reportes reportesUsuario={usuario.permisos?.filter(p => p.includes("reporte:"))} />
			</div>
		</div>
	</>);
};

export default Form;
